/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ created: NonNullable<unknown>, skipped: NonNullable<unknown> }} Generate_ResultInputs */

const th_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เพิ่ม ${i?.created} รายการ มีอยู่แล้ว ${i?.skipped} รายการ`)
};

const en_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} added, ${i?.skipped} already scheduled.`)
};

const ja_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} 件を追加、${i?.skipped} 件は既存。`)
};

const zh_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`新增 ${i?.created} 场，${i?.skipped} 场已安排。`)
};

const es_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} añadidos, ${i?.skipped} ya programados.`)
};

const pt_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} adicionados, ${i?.skipped} já agendados.`)
};

const id_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} ditambahkan, ${i?.skipped} sudah dijadwalkan.`)
};

const fr_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} ajoutés, ${i?.skipped} déjà programmés.`)
};

const tl_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} ang naidagdag, ${i?.skipped} ang nakaiskedyul na.`)
};

const vi_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã thêm ${i?.created}, ${i?.skipped} đã có lịch.`)
};

const ko_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created}개 추가, ${i?.skipped}개는 이미 편성되어 있었습니다.`)
};

const de_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} hinzugefügt, ${i?.skipped} bereits angesetzt.`)
};

const ru_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Добавлено ${i?.created}, уже назначено ${i?.skipped}.`)
};

const tr_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} eklendi, ${i?.skipped} zaten planlanmıştı.`)
};

const it_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} aggiunte, ${i?.skipped} già in calendario.`)
};

const pl_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dodano ${i?.created}, ${i?.skipped} już zaplanowano.`)
};

const uk_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Додано ${i?.created}, уже заплановано ${i?.skipped}.`)
};

const hi_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} जोड़े गए, ${i?.skipped} पहले से निर्धारित थे।`)
};

const ar_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أُضيفت ${i?.created}، و${i?.skipped} مجدولة سلفًا.`)
};

const ms_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} ditambah, ${i?.skipped} sudah dijadualkan.`)
};

const bn_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created}টি যোগ হয়েছে, ${i?.skipped}টি আগেই নির্ধারিত ছিল।`)
};

const zh_tw2_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`新增 ${i?.created} 場，${i?.skipped} 場已安排。`)
};

const zh_hk2_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`新增 ${i?.created} 場，${i?.skipped} 場已安排。`)
};

const ur_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} شامل ہوئے، ${i?.skipped} پہلے ہی طے تھے۔`)
};

const fa_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} افزوده شد، ${i?.skipped} از پیش برنامه‌ریزی شده بود.`)
};

const sw_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} zimeongezwa, ${i?.skipped} zilikuwa tayari zimepangwa.`)
};

const nl_generate_result = /** @type {(inputs: Generate_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} toegevoegd, ${i?.skipped} stonden al ingepland.`)
};

/**
* | output |
* | --- |
* | "{created} added, {skipped} already scheduled." |
*
* @param {Generate_ResultInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const generate_result = /** @type {((inputs: Generate_ResultInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generate_ResultInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_generate_result(inputs)
	if (locale === "ja") return ja_generate_result(inputs)
	if (locale === "zh") return zh_generate_result(inputs)
	if (locale === "es") return es_generate_result(inputs)
	if (locale === "pt") return pt_generate_result(inputs)
	if (locale === "id") return id_generate_result(inputs)
	if (locale === "fr") return fr_generate_result(inputs)
	if (locale === "tl") return tl_generate_result(inputs)
	if (locale === "vi") return vi_generate_result(inputs)
	if (locale === "ko") return ko_generate_result(inputs)
	if (locale === "de") return de_generate_result(inputs)
	if (locale === "ru") return ru_generate_result(inputs)
	if (locale === "tr") return tr_generate_result(inputs)
	if (locale === "it") return it_generate_result(inputs)
	if (locale === "pl") return pl_generate_result(inputs)
	if (locale === "uk") return uk_generate_result(inputs)
	if (locale === "hi") return hi_generate_result(inputs)
	if (locale === "ar") return ar_generate_result(inputs)
	if (locale === "ms") return ms_generate_result(inputs)
	if (locale === "bn") return bn_generate_result(inputs)
	if (locale === "zh-TW") return zh_tw2_generate_result(inputs)
	if (locale === "zh-HK") return zh_hk2_generate_result(inputs)
	if (locale === "ur") return ur_generate_result(inputs)
	if (locale === "fa") return fa_generate_result(inputs)
	if (locale === "sw") return sw_generate_result(inputs)
	if (locale === "nl") return nl_generate_result(inputs)
	return en_generate_result(inputs)
});